import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Trans, withI18n } from 'lingui-react';
import { compose, setDisplayName } from 'recompose';

import ElapsedTime from 'components/ElapsedTime';

import { CASE_STATUS } from 'compositions/CaseStatus';

import countOfTime from 'utils/countOfTime';

import withCaseDelays from '../withCaseDelays';

const EXCLUDED_STATUSES = [
  CASE_STATUS.canceled,
  CASE_STATUS.closed,
  CASE_STATUS.rolling,
  CASE_STATUS.closed_canceled,
];

function AssetDowntime({
  assetDowntimeMs,
  createdAt,
  i18n,
  status: caseStatus,
}) {
  const displayStaticTime = EXCLUDED_STATUSES.includes(caseStatus);

  const LiveDowntime = () => <ElapsedTime inline sinceTime={createdAt} />;

  const StaticDowntime = () => (
    <span>
      {countOfTime(moment.duration(assetDowntimeMs, 'milliseconds'), { i18n })}
    </span>
  );

  const DowntimeDisplay = displayStaticTime ? StaticDowntime : LiveDowntime;

  return (
    <Trans>
      <DowntimeDisplay /> Downtime
    </Trans>
  );
}

AssetDowntime.propTypes = {
  assetDowntimeMs: PropTypes.number,
  createdAt: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    _: PropTypes.func.isRequired,
  }).isRequired,
  status: PropTypes.string.isRequired,
};

AssetDowntime.defaultProps = {
  assetDowntimeMs: undefined,
};

export default compose(
  setDisplayName('AssetDowntime'),
  withCaseDelays,
  withI18n(),
)(AssetDowntime);



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/CaseTimeSummaries/AssetDowntime.js